import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const SegmentInsights = lazy(() =>
  import("@scenes/SegmentInsights/SegmentInsightsPage").then((module) => ({
    default: module.SegmentInsightsPage,
  }))
);

export const segmentInsightsNRO: NavigationRoutingObject = {
  section: "analytics",
  Component: SegmentInsights,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) => t("segment-insights-sidebar-pill-menu-option", "Segment Insights"),
  pageNameForTracking: () => "Segment Insights",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("segment-insights-alt-keyword-1", "session frequency"),
        t("segment-insights-alt-keyword-2", "time since first session"),
        t("segment-insights-alt-keyword-3", "time since last session"),
        t("segment-insights-alt-keyword-4", "lifetime revenue"),
        t("segment-insights-alt-keyword-5", "time to first purchase"),
        t("segment-insights-alt-keyword-6", "time since last purchase"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
